import Model from "./base/model";

class CompanyFeatures extends Model{
  resourceName() {
    return "company_features";
  }

  fields() {
    return {
      feature_id: "",
      configurations: "",
      company: { jsonApi: "hasOne", type: "companies"},
    };
  }

  async setFeature(company_id,data) {
    return this.request(
      "companies/set_feature/" + company_id,
      "POST",
      {},
      data
    );
  }

  findByCompanyId(companyId, params = {}, options = {}) {
    return this.request(
      "company_features/company/" + companyId,
      "GET",
      params,
      null,
      null,
      options
    );
  }

}

export default new CompanyFeatures();
